var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3986 4.3986C6.34317 2.45406 9.0317 1.25 12 1.25C14.9683 1.25 17.6568 2.45406 19.6014 4.3986L19.0711 4.92893L19.6014 4.3986C21.5459 6.34317 22.75 9.0317 22.75 12C22.75 14.9683 21.5459 17.6568 19.6014 19.6014C17.6568 21.5459 14.9683 22.75 12 22.75C9.0317 22.75 6.34317 21.5459 4.3986 19.6014L4.92893 19.0711L4.3986 19.6014C2.45406 17.6568 1.25 14.9683 1.25 12C1.25 9.0317 2.45406 6.34317 4.3986 4.3986L4.3986 4.3986ZM12 2.75C9.4455 2.75 7.13403 3.78452 5.45926 5.45926C3.78451 7.13404 2.75 9.4455 2.75 12C2.75 14.5545 3.78452 16.866 5.45926 18.5407C7.13403 20.2155 9.4455 21.25 12 21.25C14.5545 21.25 16.866 20.2155 18.5407 18.5407C20.2155 16.866 21.25 14.5545 21.25 12C21.25 9.4455 20.2155 7.13403 18.5407 5.45926C16.866 3.78452 14.5545 2.75 12 2.75Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.5C12.6904 5.5 13.25 6.05965 13.25 6.75C13.25 7.44035 12.6904 8 12 8C11.3097 8 10.75 7.44035 10.75 6.75C10.75 6.05965 11.3097 5.5 12 5.5Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10C10.5 9.58579 10.8358 9.25 11.25 9.25H12.25C12.6642 9.25 13 9.58579 13 10V17C13 17.4142 12.6642 17.75 12.25 17.75C11.8358 17.75 11.5 17.4142 11.5 17V10.75H11.25C10.8358 10.75 10.5 10.4142 10.5 10Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 17C9.75 16.5858 10.0858 16.25 10.5 16.25H14C14.4142 16.25 14.75 16.5858 14.75 17C14.75 17.4142 14.4142 17.75 14 17.75H10.5C10.0858 17.75 9.75 17.4142 9.75 17Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f1fb4788058738f567c0230c3b027110.svg";
export { ForwardRef as ReactComponent };